import { Account } from '../logic/account';
import { Storage } from "./storage";

export { Account };

export const accountStorage = new Storage<Account>('/api/account', 'account', defaultAccount(), false);

export function defaultAccount() {
  return Account.default();
}